import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Services() {
    return (
        <section className="relative p-0 first">
            <section className='max-md:px-0'>
                <div className="">
                {/* Header */}
                    <div className="text-center mb-16">
                        <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/60 backdrop-blur-sm border border-brand-orange/50 mb-6">
                            <span className="text-sm font-medium text-black">Our Services</span>
                        </div>
                        <h2 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent mb-4">
                            <span className="text-4xl md:text-6xl">OUR SERVICES</span>
                        </h2>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto max-md:max-w-[90%]">
                            Transform your business with our comprehensive suite of digital solutions designed to drive growth and engagement.
                        </p>
                    </div>
                    <div className='md:space-y-6'>
                        <section className="top-0 bg-gray-100">
                            <div className="max-w-7xl mx-auto">
                                <div className="grid lg:grid-cols-3 gap-8 lg:gap-16 items-center">
                                    {/* Left Content */}
                                    <div className="space-y-3 md:space-y-6">
                                        <h1 className="text-4xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                                            Brand Identity Design
                                        </h1>
                                        <p className="text-base md:text-base text-black leading-relaxed max-w-lg">
                                            Logos, colors, typography & brand guidelines that define you.
                                        </p>
                                        <Link className='block mt-4' to='/contact'>
                                            <button className="black">
                                                Build Your Brand
                                                <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
                                            </button>
                                        </Link>
                                    </div>

                                    {/* Services List */}
                                    <div className="space-y-3">
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Logo Design</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Brand Guidelines</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Color Palette</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Typography</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Visual Identity</div>
                                    </div>

                                    {/* Right Mockup Showcase */}
                                    <div>
                                        <img src="/home/hero/1.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="top-0 bg-black [&_*]:text-white">
                            <div className="max-w-7xl mx-auto">
                                <div className="grid lg:grid-cols-3 gap-8 lg:gap-16 items-center">
                                    {/* Left Content */}
                                    <div className="space-y-3 md:space-y-6">
                                        <h1 className="text-4xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                                            Social Media Management
                                        </h1>
                                        <p className="text-base md:text-base text-black leading-relaxed max-w-lg">
                                            We handle everything from content planning and posting to audience growth strategies. This includes creating engaging reels, eye-catching thumbnails,and posters tailored to your brand so you can build a strong presence across all platforms.
                                        </p>
                                        <Link className='block mt-4' to='/contact'>
                                            <button className="white">
                                                Grow Your Presence
                                                <ArrowUpRight color='black' className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
                                            </button>
                                        </Link>
                                    </div>

                                    {/* Services List */}
                                    <div className="space-y-3">
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Content Planning</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Social Media Posting</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Audience Growth</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Engaging Reels</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Thumbnails</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Custom Posters</div>
                                    </div>

                                    {/* Right Mockup Showcase */}
                                    <div>
                                        <img src="/home/hero/1.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="top-0 bg-gray-100">
                            <div className="max-w-7xl mx-auto">
                                <div className="grid lg:grid-cols-3 gap-8 lg:gap-16 items-center">
                                    {/* Left Content */}
                                    <div className="space-y-3 md:space-y-6">
                                        <h1 className="text-4xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                                            Graphic Design & Content Creation
                                        </h1>
                                        <p className="text-base md:text-base text-black leading-relaxed max-w-lg">
                                            Engaging visuals for digital, print, and campaigns to help you communicate effectively and look professional.
                                        </p>
                                        <Link className='block mt-4' to='/contact'>
                                            <button className="black">
                                                Create Visual Impact
                                                <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
                                            </button>
                                        </Link>
                                    </div>

                                    {/* Services List */}
                                    <div className="space-y-3">
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Digital Visuals</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Print Design</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Campaign Materials</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Professional Graphics</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Content Creation</div>
                                    </div>

                                    {/* Right Mockup Showcase */}
                                    <div>
                                        <img src="/home/hero/1.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="top-0 bg-black [&_*]:text-white">
                            <div className="max-w-7xl mx-auto">
                                <div className="grid lg:grid-cols-3 gap-8 lg:gap-16 items-center">
                                    {/* Left Content */}
                                    <div className="space-y-3 md:space-y-6">
                                        <h1 className="text-4xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                                            Website & Landing Pages
                                        </h1>
                                        <p className="text-base md:text-base text-black leading-relaxed max-w-lg">
                                            We build modern, responsive websites and landing pages that showcase your brand and provide a seamless experience for your visitors.
                                        </p>
                                        <Link className='block mt-4' to='/contact'>
                                            <button className="white">
                                                Build Your Website
                                                <ArrowUpRight color='black' className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
                                            </button>
                                        </Link>
                                    </div>

                                    {/* Services List */}
                                    <div className="space-y-3">
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Modern Websites</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Responsive Design</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Landing Pages</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Brand Showcase</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">User Experience</div>
                                    </div>

                                    {/* Right Mockup Showcase */}
                                    <div>
                                        <img src="/home/hero/1.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="top-0 bg-gray-100">
                            <div className="max-w-7xl mx-auto">
                                <div className="grid lg:grid-cols-3 gap-8 lg:gap-16 items-center">
                                    {/* Left Content */}
                                    <div className="space-y-3 md:space-y-6">
                                        <h1 className="text-4xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                                            Ads & Campaign Creatives
                                        </h1>
                                        <p className="text-base md:text-base text-black leading-relaxed max-w-lg">
                                            We create attention-grabbing ad designs that are optimized for performance across platforms, helping you get more clicks, leads, and sales.
                                        </p>
                                        <Link className='block mt-4' to='/contact'>
                                            <button className="black">
                                                Launch Your Campaign
                                                <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
                                            </button>
                                        </Link>
                                    </div>

                                    {/* Services List */}
                                    <div className="space-y-3">
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Attention-Grabbing</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Ad Designs</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Performance Optimized</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Cross Platform</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">More Clicks</div>
                                        <div className="text-lg md:text-base text-gray-800 font-medium">Leads & Sales</div>
                                    </div>

                                    {/* Right Mockup Showcase */}
                                    <div>
                                        <img src="/home/hero/1.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </section>

            <style jsx>{`
        @keyframes fadeInUp {
            from {
                opacity: 0;
                transform: translateY(30px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
    `}</style>
        </section>
    )
}